import { createHttpClient } from "@intergamma/account"
import type {
  OrderLookupRequest,
  OrderReturnAnnouncementV3,
  ReturnableOrderV3,
  ReturnSplitRequest,
} from "../base-api/generated"

export const PAGE_SIZE = 10

export function createRequestReturnService(MYACCOUNT_URL: string) {
  const baseClient = createHttpClient(`${MYACCOUNT_URL}/api/request-return/v3`, {
    withCredentials: true,
  })

  return {
    orderLookUp(body: OrderLookupRequest): Promise<ReturnableOrderV3 | null> {
      return baseClient.post(`/order-lookup`, JSON.stringify(body), {
        headers: {
          "Content-Type": "application/json",
        },
      })
    },
    orderSplit(body: ReturnSplitRequest): Promise<ReturnableOrderV3 | null> {
      return baseClient.post(`/order-split`, JSON.stringify(body), {
        headers: {
          "Content-Type": "application/json",
        },
      })
    },
    announce(body: OrderReturnAnnouncementV3): Promise<void> {
      return baseClient.post(`/announce`, JSON.stringify(body), {
        headers: {
          "Content-Type": "application/json",
        },
      })
    },
  }
}
